import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SidebarData from "../Sidebar/SidebarData";
import Swal from "sweetalert2";
import "./Header.css";

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const storedToken = localStorage.getItem("userToken");
  const isAdmin = localStorage.getItem("isAdmin");

useEffect(() => {

  if(!storedToken || isAdmin != "false"){

    localStorage.clear();
    navigate("/");
      }
    }, [isAdmin, navigate]);

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent event propagation
    setOpen(!open); // Toggle sidebar
  };


  const logout = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Log Out",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/"); // Redirect to home after logout
      }
    });
  };

  return (
    <>
      <div className="header-top">
        <Container>
          <Row className="d-flex align-items-center justify-content-between">
            <Col xs={5} md={5}>
              <div
                className="menuicon d-flex justify-content-between align-items-center"
                onClick={() => window.scrollTo(0, 0)}
              >
                <i className="bi bi-list" onClick={handleClick}></i>
                <div className="word_wrap_header"></div>
              </div>
            </Col>

              <h3>Admin</h3>
          
          </Row>
        </Container>
      </div>

      <div className={open ? "sidebar is-toggle" : "sidebar"}>
        <Button className="closebtn" onClick={handleClick}>
          &times;
        </Button>

        <ul className="bg-white menulist">
          {SidebarData.map((val) => (
            <li key={val.title}>
              {val.title === "Logout" ? (
                <Link
                  to={val.path || "#"} // Fallback to "#" if path is undefined
                  onClick={(e) => {
                    e.preventDefault();
                    logout(e);
                  }}
                  className={val.ownclass}
                >
                  <div className="iconmenu">{val.icon}</div>
                  {val.title}
                </Link>
              ) : (
                <Link
                  to={val.path}
                  // onClick={() => setOpen(false)} // Close sidebar on navigation
                  className={val.ownclass}
                >
                  <div className="iconmenu">{val.icon}</div>
                  <div className="menulistsidebar">
                    {val.title}
                  </div>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div
        className={`sidebar-overlay ${open ? "active" : ""}`}
        onClick={handleClick}
      ></div>
    </>
  );
}